import { ToggleButton, ToggleButtonGroup, Chip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RewardType } from '../../types/campaign';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: '#F3F4F6',
  padding: theme.spacing(0.5),
  borderRadius: '8px',
  border: '1px solid #E5E7EB',
  '& .MuiToggleButton-root': {
    border: 'none',
    borderRadius: '6px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    padding: theme.spacing(1, 2),
    color: '#6B7280',
    fontFamily: '"Inter", sans-serif',
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: '#4F46E5',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      '&:hover': {
        backgroundColor: 'white'
      }
    },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.5)'
    }
  }
}));

interface RewardTypeToggleProps {
  value: RewardType;
  onChange: (_event: React.MouseEvent<HTMLElement>, newValue: RewardType | null) => void;
}

const RewardTypeToggle = ({ value, onChange }: RewardTypeToggleProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: RewardType | null) => {
    // Prevent selecting cash reward (coming soon)
    if (newValue === 'cash') {
      return;
    }
    onChange(_event, newValue);
  };

  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      fullWidth
      sx={{ mb: 3 }}
    >
      <ToggleButton value="none">No Reward</ToggleButton>
      <ToggleButton value="coupon">Coupon</ToggleButton>
      <ToggleButton 
        value="cash" 
        disabled
        sx={{
          position: 'relative',
          opacity: 0.6,
          cursor: 'not-allowed',
          '&.Mui-disabled': {
            color: '#9CA3AF'
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', justifyContent: 'center' }}>
          <span>Cash Payout</span>
          <Chip
            label="Coming Soon"
            size="small"
            sx={{
              bgcolor: '#FEF3C7',
              color: '#92400E',
              fontSize: '0.625rem',
              fontWeight: 600,
              height: 18,
              '& .MuiChip-label': {
                px: 0.75
              }
            }}
          />
        </Box>
      </ToggleButton>
    </StyledToggleButtonGroup>
  );
};

export default RewardTypeToggle;

